{% block sw_extension_store_update_warning %}
    <sw-extension-store-error-card
        variant="info"
        class="sw-extension-store-update-warning"
        :title="$t('sw-extension-store.updateWarning.headline')"
    >
        <template #default>
            {% block sw_extension_store_update_warning_description %}
                <p>
                    {{ $t('sw-extension-store.updateWarning.description') }}
                </p>
                <p class="sw-extension-store-update-warning__strong-text">
                    {{ $t('sw-extension-store.updateWarning.requestDescription') }}
                </p>
            {% endblock %}
        </template>

        <template #actions>
            {% block sw_extension_store_update_warning_actions %}
                <mt-button
                    variant="primary"
                    :is-loading="isUpdating"
                    @click="updateExtension"
                >
                    {{ $t('sw-extension-store.updateWarning.update') }}
                </mt-button>
            {% endblock %}
        </template>
    </sw-extension-store-error-card>
{% endblock %}
